import { type RefObject, useLayoutEffect } from "react";

export function useScrollProgress({
  scrollRef,
  targetRef,
  range,
  varName = "--panel-progress",
}: {
  scrollRef: RefObject<HTMLElement | null>;
  targetRef: RefObject<HTMLElement | null>;
  range: number;
  varName?: string;
}) {
  useLayoutEffect(() => {
    const scrollEl = scrollRef.current;
    const targetEl = targetRef.current;
    if (!scrollEl || !targetEl || range <= 0) return;

    let raf = 0;
    const apply = () => {
      raf = 0;
      const progress = Math.max(0, Math.min(1, scrollEl.scrollTop / range));
      targetEl.style.setProperty(varName, String(progress));
    };
    const onScroll = () => {
      if (raf) return;
      raf = requestAnimationFrame(apply);
    };

    apply();
    scrollEl.addEventListener("scroll", onScroll, { passive: true });
    return () => {
      scrollEl.removeEventListener("scroll", onScroll);
      if (raf) cancelAnimationFrame(raf);
    };
  }, [scrollRef, targetRef, range, varName]);
}
